(function () {
	const expandedFilters = new Set();
	const pinnedOpen = new Set();
	const pinnedClosed = new Set();
	const MAX_VISIBLE = 10;
	const MIN_VISIBLE = 4;
	const MIN_HIDDEN = 3;
	const OVERFLOW_SLOP = 24;
	let resizeBound = false;
	let suppressToggle = false;
	let fitting = false;
	let motionLock = false;
	const MOTION_MS = 280;

	const facetsMenu = () => {
		$("html.js .no_submit").click(function (e) {
			e.preventDefault();
		});
		$(
			".open_filters,.facets-menu__close,.facets__submit,.facets__reset,.form-menu__mask"
		).click(function () {
			$("#open_filters_menu").toggleClass("show_menu");
			$("body").toggleClass("overflow-hidden");
			window.requestAnimationFrame(fitFacetMenus);
		});
		document.querySelectorAll(".facets-menu").forEach((menu) => {
			if (menu.dataset.facetFitBound === "true") return;
			menu.dataset.facetFitBound = "true";
			menu.addEventListener("click", (event) => {
				const summary = event.target.closest("summary");
				if (!summary || summary.parentElement?.classList.contains("js-filter") !== true) return;
				event.preventDefault();
				onSummaryClick(menu, summary.parentElement);
			});
			menu.querySelectorAll("details.js-filter").forEach((details) => {
				const onUserToggle = () => {
					if (suppressToggle || fitting || motionLock) return;
					const key = details.id;
					if (!key) return;
					if (details.open) {
						pinnedOpen.add(key);
						pinnedClosed.delete(key);
					} else {
						pinnedClosed.add(key);
						pinnedOpen.delete(key);
						expandedFilters.delete(key);
					}
					fitFacetMenu(menu);
				};
				new MutationObserver(onUserToggle).observe(details, {
					attributes: true,
					attributeFilter: ["open"],
				});
			});
		});
		fitFacetMenus();
	};

	function labelText(menu, name, fallback) {
		const value = menu.getAttribute(name);
		if (!value || value.indexOf("Translation missing") !== -1) return fallback;
		return value;
	}

	function overflowAmount(menu) {
		return menu.scrollHeight - menu.clientHeight;
	}

	function isOverflowing(menu) {
		return overflowAmount(menu) > OVERFLOW_SLOP;
	}

	function sectionsFor(menu) {
		return [...menu.querySelectorAll("details.js-filter")]
			.map((details) => {
				const list = [...details.querySelectorAll(".facets__list")].find((node) =>
					node.querySelector(".facets-checkbox__hide")
				);
				const items = list
					? [...list.children].filter((node) =>
							node.classList.contains("facets__item")
						)
					: [];
				return {
					details,
					list,
					items,
					key: details.id,
					top: details.getBoundingClientRect().top,
				};
			})
			.filter((section) => section.key)
			.sort((a, b) => a.top - b.top);
	}

	function removeToggle(section) {
		if (!section.list) return;
		const button = section.list.parentElement?.querySelector(".facets__show-more");
		if (button) button.remove();
	}

	function showAll(section) {
		section.items.forEach((item) => {
			item.hidden = false;
		});
	}

	function hideOverflow(section, visibleCount) {
		const checked = [];
		const rest = [];
		section.items.forEach((item) => {
			const input = item.querySelector('input[type="checkbox"]');
			if (input && input.checked) checked.push(item);
			else rest.push(item);
		});
		const slots = Math.max(visibleCount, checked.length);
		const shown = new Set(
			checked.concat(rest.slice(0, Math.max(0, slots - checked.length)))
		);
		const hidden = [];
		section.items.forEach((item) => {
			const isHidden = !shown.has(item);
			item.hidden = isHidden;
			if (isHidden) hidden.push(item);
		});
		return hidden;
	}

	function renderToggle(menu, section, expanded, hiddenCount) {
		removeToggle(section);
		if (!section.list) return;
		const button = document.createElement("button");
		button.type = "button";
		button.className = "facets__show-more no_submit";
		button.setAttribute("aria-expanded", expanded ? "true" : "false");
		const more = labelText(menu, "data-view-more", "View more");
		const less = labelText(menu, "data-view-less", "View less");
		button.textContent = expanded
			? less
			: hiddenCount
				? more + " (" + hiddenCount + ")"
				: more;
		button.addEventListener("click", (event) => {
			event.preventDefault();
			event.stopPropagation();
			const expanding = !expandedFilters.has(section.key);
			if (expanding) expandedFilters.add(section.key);
			else expandedFilters.delete(section.key);
			pinnedOpen.add(section.key);
			pinnedClosed.delete(section.key);
			const changing = expanding
				? section.items.filter((item) => item.hidden)
				: itemsPastCap(section);
			if (!changing.length || reducedMotion()) {
				fitFacetMenu(menu);
				return;
			}
			animateItems(menu, changing, expanding);
		});
		const fieldset = section.list.closest("fieldset") || section.list.parentElement;
		fieldset.appendChild(button);
	}

	function setOpen(details, open) {
		if (details.open === open) return;
		suppressToggle = true;
		details.open = open;
		queueMicrotask(() => {
			suppressToggle = false;
		});
	}

	function reducedMotion() {
		return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	}

	function panelOf(details) {
		return [...details.children].find((node) => node.tagName !== "SUMMARY");
	}

	function clearMotion(node) {
		node.style.height = "";
		node.style.overflow = "";
		node.style.transition = "";
		node.style.opacity = "";
		node.style.marginBottom = "";
	}

	function nextFrame() {
		return new Promise((resolve) => {
			window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
		});
	}

	function waitForHeight(nodes) {
		const list = nodes.filter(Boolean);
		if (!list.length) return Promise.resolve();
		return new Promise((resolve) => {
			let pending = list.length;
			let settled = false;
			const finish = () => {
				if (settled) return;
				settled = true;
				resolve();
			};
			const timer = window.setTimeout(finish, MOTION_MS + 70);
			list.forEach((node) => {
				node.addEventListener("transitionend", function onEnd(event) {
					if (event.target !== node || event.propertyName !== "height") return;
					node.removeEventListener("transitionend", onEnd);
					pending -= 1;
					if (pending <= 0) {
						window.clearTimeout(timer);
						finish();
					}
				});
			});
		});
	}

	function itemsPastCap(section) {
		const checked = [];
		const rest = [];
		section.items.forEach((item) => {
			const input = item.querySelector('input[type="checkbox"]');
			if (input && input.checked) checked.push(item);
			else rest.push(item);
		});
		const slots = Math.max(MAX_VISIBLE, checked.length);
		const shown = new Set(
			checked.concat(rest.slice(0, Math.max(0, slots - checked.length)))
		);
		return section.items.filter((item) => !shown.has(item) && !item.hidden);
	}

	function onSummaryClick(menu, details) {
		if (motionLock || fitting) return;
		const key = details.id;
		if (!key) return;
		const opening = !details.open;
		if (opening) {
			pinnedOpen.add(key);
			pinnedClosed.delete(key);
		} else {
			pinnedClosed.add(key);
			pinnedOpen.delete(key);
			expandedFilters.delete(key);
		}
		if (reducedMotion()) {
			setOpen(details, opening);
			fitFacetMenu(menu);
			return;
		}
		animateSection(menu, details, opening);
	}

	function animateSection(menu, details, opening) {
		const panel = panelOf(details);
		motionLock = true;
		const done = () => {
			if (panel) clearMotion(panel);
			motionLock = false;
			fitFacetMenu(menu);
		};
		if (!panel) {
			setOpen(details, opening);
			done();
			return;
		}
		if (opening) {
			setOpen(details, true);
			panel.style.overflow = "hidden";
			panel.style.transition = "none";
			panel.style.height = "0px";
			const target = panel.scrollHeight;
			nextFrame().then(() => {
				panel.style.transition = "height " + MOTION_MS + "ms ease";
				panel.style.height = target + "px";
				return waitForHeight([panel]);
			}).then(done);
			return;
		}
		panel.style.overflow = "hidden";
		panel.style.transition = "none";
		panel.style.height = panel.scrollHeight + "px";
		nextFrame().then(() => {
			panel.style.transition = "height " + MOTION_MS + "ms ease";
			panel.style.height = "0px";
			return waitForHeight([panel]);
		}).then(() => {
			setOpen(details, false);
			done();
		});
	}

	function animateItems(menu, items, show) {
		motionLock = true;
		const finish = () => {
			items.forEach(clearMotion);
			motionLock = false;
			fitFacetMenu(menu);
		};
		if (show) {
			items.forEach((item) => {
				item.hidden = false;
			});
			const heights = items.map((item) => item.getBoundingClientRect().height);
			const margins = items.map((item) => getComputedStyle(item).marginBottom);
			items.forEach((item) => {
				item.style.overflow = "hidden";
				item.style.transition = "none";
				item.style.height = "0px";
				item.style.marginBottom = "0px";
				item.style.opacity = "0";
			});
			nextFrame().then(() => {
				items.forEach((item, index) => {
					item.style.transition =
						"height " + MOTION_MS + "ms ease, margin-bottom " + MOTION_MS + "ms ease, opacity " + MOTION_MS + "ms ease";
					item.style.height = heights[index] + "px";
					item.style.marginBottom = margins[index];
					item.style.opacity = "1";
				});
				return waitForHeight(items);
			}).then(finish);
			return;
		}
		items.forEach((item) => {
			item.style.overflow = "hidden";
			item.style.transition = "none";
			item.style.height = item.getBoundingClientRect().height + "px";
			item.style.marginBottom = getComputedStyle(item).marginBottom;
			item.style.opacity = "1";
		});
		nextFrame().then(() => {
			items.forEach((item) => {
				item.style.transition =
					"height " + MOTION_MS + "ms ease, margin-bottom " + MOTION_MS + "ms ease, opacity " + MOTION_MS + "ms ease";
				item.style.height = "0px";
				item.style.marginBottom = "0px";
				item.style.opacity = "0";
			});
			return waitForHeight(items);
		}).then(() => {
			items.forEach((item) => {
				item.hidden = true;
			});
			finish();
		});
	}

	function hasChecked(section) {
		return section.items.some((item) => {
			const input = item.querySelector('input[type="checkbox"]');
			return input && input.checked;
		});
	}

	function mustStayOpen(section) {
		return (
			pinnedOpen.has(section.key) ||
			expandedFilters.has(section.key) ||
			hasChecked(section)
		);
	}

	function capAtMax(menu, section) {
		if (!section.list || expandedFilters.has(section.key)) return;
		if (!section.details.open || section.items.length <= MAX_VISIBLE) return;
		const hidden = hideOverflow(section, MAX_VISIBLE);
		renderToggle(menu, section, false, hidden.length);
	}

	function truncateToFit(menu, section) {
		if (!section.list || expandedFilters.has(section.key)) return;
		if (section.items.length < MIN_VISIBLE + MIN_HIDDEN) return;
		let shown = section.items.filter((item) => !item.hidden).length;
		while (isOverflowing(menu) && shown > MIN_VISIBLE) {
			shown -= 1;
			const hidden = hideOverflow(section, shown);
			if (hidden.length >= MIN_HIDDEN) {
				renderToggle(menu, section, false, hidden.length);
			}
		}
		const hiddenNow = section.items.filter((item) => item.hidden);
		if (
			hiddenNow.length > 0 &&
			hiddenNow.length < MIN_HIDDEN &&
			section.items.length <= MAX_VISIBLE
		) {
			showAll(section);
			removeToggle(section);
		}
	}

	function revealSpare(menu, sections) {
		let guard = 0;
		while (guard++ < 40) {
			const spare = menu.clientHeight - menu.scrollHeight;
			const target = sections.find((section) => {
				if (!section.details.open || expandedFilters.has(section.key)) return false;
				const shown = section.items.filter((item) => !item.hidden).length;
				return section.items.some((item) => item.hidden) && shown < MAX_VISIBLE;
			});
			if (!target) break;
			const sample = target.items.find((item) => !item.hidden) || target.items[0];
			const style = window.getComputedStyle(sample);
			const row =
				sample.getBoundingClientRect().height +
				(parseFloat(style.marginBottom) || 0);
			if (spare < row) break;
			const shown = target.items.filter((item) => !item.hidden).length;
			const hidden = hideOverflow(target, shown + 1);
			if (hidden.length < MIN_HIDDEN) {
				if (target.items.length > MAX_VISIBLE) {
					const capped = hideOverflow(target, MAX_VISIBLE);
					renderToggle(menu, target, false, capped.length);
				} else {
					showAll(target);
					removeToggle(target);
				}
			} else {
				renderToggle(menu, target, false, hidden.length);
			}
			if (isOverflowing(menu)) {
				const revert = hideOverflow(target, shown);
				if (revert.length < MIN_HIDDEN) {
					if (target.items.length > MAX_VISIBLE) {
						const capped = hideOverflow(target, MAX_VISIBLE);
						renderToggle(menu, target, false, capped.length);
					} else {
						showAll(target);
						removeToggle(target);
					}
				} else {
					renderToggle(menu, target, false, revert.length);
				}
				break;
			}
		}
	}

	function fitFacetMenu(menu) {
		if (!menu || !menu.clientHeight || fitting || motionLock) return;
		fitting = true;
		menu.classList.add("is-fitting");
		try {
			const sections = sectionsFor(menu);

			sections.forEach((section) => {
				removeToggle(section);
				showAll(section);
				if (pinnedClosed.has(section.key) && !hasChecked(section)) {
					setOpen(section.details, false);
				} else {
					setOpen(section.details, true);
				}
			});

			sections.forEach((section) => {
				if (section.details.open) capAtMax(menu, section);
			});

			if (isOverflowing(menu)) {
				for (let index = sections.length - 1; index >= 0; index--) {
					if (!isOverflowing(menu)) break;
					const section = sections[index];
					if (mustStayOpen(section)) continue;
					const openCount = sections.filter((item) => item.details.open).length;
					if (openCount <= 1) break;
					setOpen(section.details, false);
				}
			}

			sections.forEach((section) => {
				if (!section.details.open || !isOverflowing(menu)) return;
				truncateToFit(menu, section);
			});

			sections.forEach((section) => {
				if (section.details.open || pinnedClosed.has(section.key)) return;
				setOpen(section.details, true);
				capAtMax(menu, section);
				if (!isOverflowing(menu)) return;
				truncateToFit(menu, section);
				if (isOverflowing(menu)) {
					showAll(section);
					removeToggle(section);
					setOpen(section.details, false);
				}
			});

			sections.forEach((section) => {
				if (
					expandedFilters.has(section.key) &&
					section.details.open &&
					section.items.length > MAX_VISIBLE
				) {
					showAll(section);
					renderToggle(menu, section, true, 0);
				}
			});

			revealSpare(menu, sections);
		} finally {
			fitting = false;
			menu.classList.remove("is-fitting");
		}
	}

	function fitFacetMenus() {
		document.querySelectorAll(".facets-menu").forEach(fitFacetMenu);
	}

	window.fitFacetMenus = fitFacetMenus;

	document.addEventListener("DOMContentLoaded", function () {
		facetsMenu();
		if (!resizeBound) {
			resizeBound = true;
			let frame = 0;
			window.addEventListener("resize", () => {
				window.cancelAnimationFrame(frame);
				frame = window.requestAnimationFrame(fitFacetMenus);
			});
		}
	});
	document.addEventListener("shopify:section:load", function () {
		facetsMenu();
	});
})();
